import Component from '../inherited/Component'

export default class ProductGrid extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.urlState = new URL(window.location.href)
    this.productGrid = this._elem
    this.filters = this._elem.querySelectorAll('[js-product-grid="filter"]')
    this.products = this._elem.querySelector('[js-product-grid="products"]')
    this.mobileFilterTrigger = this._elem.querySelector(
      '[js-product-grid="filter-trigger"]'
    )
    this.mobileFilterClose = this._elem.querySelectorAll(
      '[js-product-grid="filter-close"]'
    )
    this.mobileFilterDrawer = this._elem.querySelector(
      '[js-product-grid="filter-drawer"]'
    )
  }

  async mount() {
    if (!this.productGrid) {
      return
    }

    this.filters.forEach(filter => {
      filter.addEventListener('change', this.handleFilterClick.bind(this))
    })

    this.mobileFilterTrigger.addEventListener('click', () => {
      this.mobileFilterDrawer.showModal()
    })

    this.mobileFilterClose.forEach(close => {
      close.addEventListener('click', () => {
        this.mobileFilterDrawer.close()
      })
    })
  }

  async handleFilterClick(event) {
    try {
      const clickedCheckbox = event.target

      this.filters.forEach(filter => {
        if (
          filter.name === clickedCheckbox.name &&
          filter !== clickedCheckbox
        ) {
          filter.checked = false
        }
      })

      this.productGrid.classList.add('is-loading')
      const { value, name } = event.target

      this.urlState.searchParams.delete('page')

      if (value) {
        this.urlState.searchParams.set(name, value)
      } else {
        this.urlState.searchParams.delete(name)
      }

      this.replaceUrlState()

      const fetchUrl = `${this.urlState.origin}/${this.urlState.pathname}${this.urlState.search}`
      const res = await fetch(fetchUrl)
      const text = await res.text()
      const html = new DOMParser().parseFromString(text, 'text/html')
      const newProductGrid = html.querySelector('[js-product-grid="products"]')

      this.products.innerHTML = newProductGrid.innerHTML
      this._theme.mountComponents()
    } catch (err) {
      console.error(err)
    } finally {
      this.productGrid.classList.remove('is-loading')
    }
  }

  replaceUrlState() {
    window.history.replaceState(
      { path: this.urlState.href },
      '',
      this.urlState.href
    )
  }
}
